import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('authtoken');
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && (result.error.status === 401)) {
    localStorage.removeItem('authtoken');
  }
  return result;
};

export const RPApi = createApi({
  reducerPath: 'RPApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getRP: builder.query({
      query: (param) => ({
        url: `/role/role-list/`,
        params: param
      })
    }),
    getAllModuleAccess: builder.query({
      query: () => ({
        url: `/role/role-deny-list`
      })
    }),
    getBRP: builder.query({
      query: (param) => ({
        url: `/accounts/list-branch-domain`,
        params: param
      })
    }),
    postRP: builder.mutation({
      query: (data) => ({
        url: `/role/role-create/`,
        method: "POST",
        body: data,
      }),
    }),
    deleteRole: builder.mutation({
      query: (id) => {

        return {
          url: `/accounts/role-delete/${id}/`,
          method: "DELETE",
        };
      },
    }),
    updateRp: builder.mutation({
      query: ({ id, roleData }) => ({
        url: `/accounts/role-update/${id}/`,
        method: "PUT",
        body: roleData,

      }),
    }),
  }),
})

export const { useGetRPQuery, useGetBRPQuery, usePostRPMutation, useDeleteRoleMutation, useUpdateRpMutation,useGetAllModuleAccessQuery } = RPApi